import { Button } from 'native-base';
import { formatDateTimes } from '../../utils/moment';
import QRCode from "react-qr-code";

export const columns = (navigate) => [
    {
        name: 'QR',
        button: true,
        cell: (row) =>
            <QRCode
                id={row.final_link}
                value={row.final_link}
                onClick={() => navigate(`/admin/qr/edit/${row._id}`)}
                size={100}
                style={{ margin: 'auto', padding: 10 }}
            />
        ,
        sortable: false,
    },
    {
        name: 'Code',
        selector: (row) => row.code,
        sortable: true,
    },
    {
        name: 'Short Link',
        selector: (row) => row.final_link,
        sortable: true,
    },
    {
        name: 'Deep Link',
        selector: (row) => row.dynamic_link,
        sortable: true,
    },
    {
        name: 'Link',
        selector: (row) => row.link,
        sortable: true,
    },
    {
        name: 'Active',
        selector: (row) => row.active,
        sortable: true,
    },
    {
        name: 'Hits',
        selector: (row) => row.hits,
        sortable: true,
    },
    {
        name: 'Created on',
        selector: (row) => formatDateTimes(row.createdAt, 4),
        sortable: true,
    },
    {
        name: 'Actions',
        button: true,
        cell: (row) => <Button
            size='sm' variant={'link'}
            onPress={() => navigate(`/admin/link_shortener/edit/${row._id}`)}>
            Edit</Button>,
        sortable: false,
    },
]